/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgMerge = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M6 2c2.206 0 4 1.794 4 4 0 1.844-1.253 3.4-2.953 3.861a8.014 8.014 0 0 0 7.092 7.093A4.006 4.006 0 0 1 18 14c2.206 0 4 1.794 4 4s-1.794 4-4 4a4.007 4.007 0 0 1-3.883-3.04A9.996 9.996 0 0 1 7 14.995V22H5V9.874A4.007 4.007 0 0 1 2 6c0-2.206 1.794-4 4-4zm12 14c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.897-2-2-2zM6 4c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.897-2-2-2z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgMerge as Merge };
